import { render } from "./NotesModal.vue?vue&type=template&id=4de85247&scoped=true&ts=true"
import script from "./NotesModal.vue?vue&type=script&lang=ts"
export * from "./NotesModal.vue?vue&type=script&lang=ts"

import "./NotesModal.vue?vue&type=style&index=0&id=4de85247&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de85247"]])

export default __exports__